import React from 'react';
import _ from 'lodash';
import AuthoringWorkflowTab from './AuthoringWorkflowTab';
import { ForgeList, ForgeMiniDrawer } from '@tylertech/forge-react';

interface ICustomizationTab {
  id: string;
  title: string;
  icon: string;
}

interface ICustomizationTabsProps {
  tabs: ICustomizationTab[];
  selection: string;
  onTabNavigation: (tabId: string) => void;
}

export const CustomizationTabs = (props: ICustomizationTabsProps) => {
  const tabAttributes = (tab: ICustomizationTab) => {
    return {
      id: tab.id,
      key: tab.id,
      title: tab.title,
      icon: tab.icon,
      selected: props.selection === tab.id,
      onTabNavigation: props.onTabNavigation,
    };
  };

  const renderTab = (tab: ICustomizationTab) => {
    return <AuthoringWorkflowTab {...tabAttributes(tab)} />;
  };

  return (
    <ForgeMiniDrawer
      direction="left"
      className="content-sidebar-tabs"
      data-testid="authoring-workflow-tabs-drawer"
    >
      <ForgeList navlist={true}>{_.map(props.tabs, renderTab)}</ForgeList>
    </ForgeMiniDrawer>
  );
};

export default CustomizationTabs;
